// activate mobile menu link
jQuery('#mobilemenulink').click(function() {
menuOpen();
});



$(document).on("pagecreate", function(event) {
  runig(this);
});

// Update the contents of the toolbars
$(document).on("pagecreate", ".ui-page", function(event) {
  setTimeout(function() {
    initmodals(event); 
  }, 1000);
});

$(document).one("pageshow", "#index", function(event) {
    
    //fix page jump
    jQuery.mobile.silentScroll(0);
   
     //load the slider  
   createhomepageslider();  
  
       // load the review slider
    reviewslider();
  
  

  
  
      // shoutouts swiper
  var mySwiper = new Swiper ('.shoutouts-swiper', {
    // Optional parameters
    direction: 'horizontal',
    autoHeight: false,
    loop: true,
     autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
    slidesPerView: 5,
    updateOnImagesReady: true,
    centeredSlides: true,
    spaceBetween: 20,
    breakpoints: {
    // when window width is <= 320px
    400: {
      slidesPerView: 1,
    }
    },
      on: {
    slideChange: function () {
     container = jQuery(this)[0].el;
     
     var name = jQuery(this.slides[this.activeIndex]).find('a').attr('name');
     var review = jQuery(this.slides[this.activeIndex]).find('a').attr('review');
     jQuery(container).find('.details').fadeOut(300, function() {
     jQuery(container).find('.details').html('<h3 class="text-center">' + name + '</h3><h2 class="text-center">' + review + '</h2>');
      }).fadeIn(300); 
      }
    }
  })
  
});





// activate instagram-slider on all pages before showing with jQuery Mobile
jQuery(document).one('pagebeforeshow', function () {
  
  
    // discount code popup
var $discountCode = getParameterByName('discount');
  // popup for homepage first time viewers    
 if($discountCode) {
   discountpopup($discountCode);
   localStorage.setItem('storedDiscount', $discountCode);   
  } 
  // discount code popup

  $(document).on('lity:ready', function(event, $lightbox, $triggeringElement) {
    if($triggeringElement) {
     if($triggeringElement.closest('.video_reviews').length || $triggeringElement.closest('.snob-video-wrap').length) {
    var caption = '<div class="text-center review-caption">Experience it for yourself!</div><div class="text-center review-button"><a href="/collections/all" class="button" data-lity-close>Shop Now</a></div>';
    $lightbox.find('.lity-content').append('<p>'+caption+'</p>');
      }
    }
});

});



jQuery(document).on("pagecreate", "#pagehelp-contact", function(event) {
  autocompletesearch();  
  helpaccordion();
});

jQuery(document).on("pagebeforeshow", "#searchfaq", function(event) {
  autocompletesearch();  
  helpaccordion();
});


function helpaccordion() {
 var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
    jQuery(acc[i]).off('click').on('click', function(){
        jQuery(this).parent().get(0).classList.toggle("active");
  });
} 
}


function autocompletesearch() {
  // Current Ajax request.
  var currentAjaxRequest = null;
  // Grabbing all search forms on the page, and adding a .search-results list to each.
  // Grabbing text input.
    
    var input = $('#helpsearch');
  
    // Listening to keyup and change on the text field within these search forms.
    input.attr('autocomplete', 'off').bind('keyup change', function() {
      // What's the search term?
      var term = $(this).val();
      // What's the search form?
      var form = $(this).closest('form');
      // What's the search URL?
      var searchURL = '/search?type=article&q=' + term;
      // What's the search results list?
      var resultsList = jQuery('#searchhelp-results');
      var resultsListWrap = jQuery('#searchhelp-results-wrap');
      // If that's a new term and it contains at least 3 characters.
      if (term.length > 3 && term != $(this).attr('data-old-term')) {
        // Saving old query.
        $(this).attr('data-old-term', term);
        // Killing any Ajax request that's currently being processed.
        if (currentAjaxRequest != null) currentAjaxRequest.abort();
        // Pulling results.
        currentAjaxRequest = $.getJSON(searchURL + '&view=json', function(data) {
          // Reset results.
          resultsList.empty();
          // If we have no results.
          if(data.results_count == 0) {
            // resultsList.html('<li><span class="title">No results.</span></li>');
            // resultsList.fadeIn(200);
            resultsListWrap.removeClass('active');
          } else {
            // If we have results.
             var i = 0;
             var results = '';
            $.each(data.results, function(index, item) {
              // get the parent blog id
              blog_id = item.object.blog_id;
              // get blog ids of help page blogs
              var help1 = 'frequently-asked-questions';
              if(item.bloghandle == help1) {
               i++;
               data.results_count = i;
               console.log(item);
               results += '<li><a href="' + item.url + '?view=faq">' + item.title + '</a></li>';
              }
              
              
            });        
            resultsList.html(results);
            resultsListWrap.addClass('active');
          }        
        });
      }else if(term.length < 3) {
        
        resultsListWrap.removeClass('active');
      }
    });

}



// createhomepage slider
function setREVStartSize(e){
				try{ var i=jQuery(window).width(),t=9999,r=0,n=0,l=0,f=0,s=0,h=0;					
					if(e.responsiveLevels&&(jQuery.each(e.responsiveLevels,function(e,f){f>i&&(t=r=f,l=e),i>f&&f>r&&(r=f,n=e)}),t>r&&(l=n)),f=e.gridheight[l]||e.gridheight[0]||e.gridheight,s=e.gridwidth[l]||e.gridwidth[0]||e.gridwidth,h=i/s,h=h>1?1:h,f=Math.round(h*f),"fullscreen"==e.sliderLayout){var u=(e.c.width(),jQuery(window).height());if(void 0!=e.fullScreenOffsetContainer){var c=e.fullScreenOffsetContainer.split(",");if (c) jQuery.each(c,function(e,i){u=jQuery(i).length>0?u-jQuery(i).outerHeight(!0):u}),e.fullScreenOffset.split("%").length>1&&void 0!=e.fullScreenOffset&&e.fullScreenOffset.length>0?u-=jQuery(window).height()*parseInt(e.fullScreenOffset,0)/100:void 0!=e.fullScreenOffset&&e.fullScreenOffset.length>0&&(u-=parseInt(e.fullScreenOffset,0))}f=u}else void 0!=e.minHeight&&f<e.minHeight&&(f=e.minHeight);e.c.closest(".rev_slider_wrapper").css({height:f})					
				}catch(d){console.log("Failure at Presize of Slider:"+d)}
			};
function createhomepageslider() {

var htmlDiv = document.getElementById("rs-plugin-settings-inline-css"); var htmlDivCss="";
				if(htmlDiv) {
					htmlDiv.innerHTML = htmlDiv.innerHTML + htmlDivCss;
				}else{
					var htmlDiv = document.createElement("div");
					htmlDiv.innerHTML = "<style>" + htmlDivCss + "</style>";
					document.getElementsByTagName("head")[0].appendChild(htmlDiv.childNodes[0]);
				}



  
					var htmlDivCss = ' #rev_slider_108_1_wrapper .tp-loader.spinner2{ background-color: #ffffff !important; } ';
					var htmlDiv = document.getElementById('rs-plugin-settings-inline-css');
					if(htmlDiv) {
						htmlDiv.innerHTML = htmlDiv.innerHTML + htmlDivCss;
					}
					else{
						var htmlDiv = document.createElement('div');
						htmlDiv.innerHTML = '<style>' + htmlDivCss + '</style>';
						document.getElementsByTagName('head')[0].appendChild(htmlDiv.childNodes[0]);
					}





setREVStartSize({c: jQuery('#rev_slider_2_1'), responsiveLevels: [1240,1024,778,480], gridwidth: [1920,1024,778,480], gridheight: [899,479,364,260], sliderLayout: 'auto'});
			
var revapi2,
	tpj=jQuery;
			
tpj(document).ready(function() {
	if(tpj("#rev_slider_2_1").revolution == undefined){
		revslider_showDoubleJqueryError("#rev_slider_2_1");
	}else{
		revapi2 = tpj("#rev_slider_2_1").show().revolution({
			sliderType:"standard",
			jsFileLocation:"",
			sliderLayout:"auto",
			dottedOverlay:"none",
			delay:9000,
			navigation: {
				onHoverStop:"off",
			},
			responsiveLevels:[1240,1024,778,480],
			visibilityLevels:[1240,1024,778,480],
			gridwidth:[1920,1024,778,480],
			gridheight:[899,479,364,260],
			lazyType:"none",
			shadow:0,
			spinner:"spinner4",
			stopLoop:"off",
			stopAfterLoops:-1,
			stopAtSlide:-1,
			shuffle:"off",
			autoHeight:"off",
			disableProgressBar:"on",
			hideThumbsOnMobile:"off",
			hideSliderAtLimit:0,
			hideCaptionAtLimit:0,
			hideAllCaptionAtLilmit:0,
			debugMode:false,
			fallbacks: {
				simplifyAll:"off",
				nextSlideOnWindowFocus:"off",
				disableFocusListener:false,
			}
		});
	}
	
});	
  setTimeout(function() {
     window.homeSlider = true; 
     jQuery( "#rev_slider_108_1 a[target]" ).removeAttr( "target" );
  }, 300);
}




$(document).one("pageshow", "#pageour-why", function(event) {
    createourwhyslider();
});


// createhomepage slider
function createourwhyslider() {
  
var htmlDiv = document.getElementById("rs-plugin-settings-inline-css"); var htmlDivCss="";
						if(htmlDiv) {
							htmlDiv.innerHTML = htmlDiv.innerHTML + htmlDivCss;
						}else{
							var htmlDiv = document.createElement("div");
							htmlDiv.innerHTML = "<style>" + htmlDivCss + "</style>";
							document.getElementsByTagName("head")[0].appendChild(htmlDiv.childNodes[0]);
						}


 
					var htmlDivCss = ' #rev_slider_160_1_wrapper .tp-loader.spinner2{ background-color: #b7a549 !important; } ';
					var htmlDiv = document.getElementById('rs-plugin-settings-inline-css');
					if(htmlDiv) {
						htmlDiv.innerHTML = htmlDiv.innerHTML + htmlDivCss;
					}
					else{
						var htmlDiv = document.createElement('div');
						htmlDiv.innerHTML = '<style>' + htmlDivCss + '</style>';
						document.getElementsByTagName('head')[0].appendChild(htmlDiv.childNodes[0]);
					}

  var htmlDivCss = unescape("%23rev_slider_160_1%20.uranus%20.tp-bullet%7B%0A%20%20border-radius%3A%2050%25%3B%0A%20%20box-shadow%3A%200%200%200%202px%20rgba%28255%2C%20255%2C%20255%2C%200%29%3B%0A%20%20-webkit-transition%3A%20box-shadow%200.3s%20ease%3B%0A%20%20transition%3A%20box-shadow%200.3s%20ease%3B%0A%20%20background%3Atransparent%3B%0A%20%20width%3A15px%3B%0A%20%20height%3A15px%3B%0A%7D%0A%23rev_slider_160_1%20.uranus%20.tp-bullet.selected%2C%0A%23rev_slider_160_1%20.uranus%20.tp-bullet%3Ahover%20%7B%0A%20%20box-shadow%3A%200%200%200%202px%20rgba%28255%2C%20255%2C%20255%2C1%29%3B%0A%20%20border%3Anone%3B%0A%20%20border-radius%3A%2050%25%3B%0A%20%20background%3Atransparent%3B%0A%7D%0A%0A%23rev_slider_160_1%20.uranus%20.tp-bullet-inner%20%7B%0A%20%20-webkit-transition%3A%20background-color%200.3s%20ease%2C%20-webkit-transform%200.3s%20ease%3B%0A%20%20transition%3A%20background-color%200.3s%20ease%2C%20transform%200.3s%20ease%3B%0A%20%20top%3A%200%3B%0A%20%20left%3A%200%3B%0A%20%20width%3A%20100%25%3B%0A%20%20height%3A%20100%25%3B%0A%20%20outline%3A%20none%3B%0A%20%20border-radius%3A%2050%25%3B%0A%20%20background-color%3A%20rgb%28255%2C%20255%2C%20255%29%3B%0A%20%20background-color%3A%20rgba%28255%2C%20255%2C%20255%2C%200.3%29%3B%0A%20%20text-indent%3A%20-999em%3B%0A%20%20cursor%3A%20pointer%3B%0A%20%20position%3A%20absolute%3B%0A%7D%0A%0A%23rev_slider_160_1%20.uranus%20.tp-bullet.selected%20.tp-bullet-inner%2C%0A%23rev_slider_160_1%20.uranus%20.tp-bullet%3Ahover%20.tp-bullet-inner%7B%0A%20transform%3A%20scale%280.4%29%3B%0A%20-webkit-transform%3A%20scale%280.4%29%3B%0A%20background-color%3Argb%28255%2C%20255%2C%20255%29%3B%0A%7D%0A");
					var htmlDiv = document.getElementById('rs-plugin-settings-inline-css');
					if(htmlDiv) {
						htmlDiv.innerHTML = htmlDiv.innerHTML + htmlDivCss;
					}
					else{
						var htmlDiv = document.createElement('div');
						htmlDiv.innerHTML = '<style>' + htmlDivCss + '</style>';
						document.getElementsByTagName('head')[0].appendChild(htmlDiv.childNodes[0]);
					}


			
			setREVStartSize({c: jQuery('#rev_slider_160_1'), responsiveLevels: [1240,1024,778,480], gridwidth: [1920,1280,778,480], gridheight: [1080,800,534,728], sliderLayout: 'fullscreen', fullScreenAutoWidth:'off', fullScreenAlignForce:'off', fullScreenOffsetContainer:'#header', fullScreenOffset:''});

			
						var tpj=jQuery;
			
			var revapi160;
		
				if(tpj("#rev_slider_160_1").revolution == undefined){
					revslider_showDoubleJqueryError("#rev_slider_160_1");
				}else{
					revapi160 = tpj("#rev_slider_160_1").show().revolution({
						sliderType:"standard",
jsFileLocation:"",
						sliderLayout:"fullscreen",
			dottedOverlay:"none",
			delay:9000,
			navigation: {
				keyboardNavigation:"off",
				keyboard_direction: "horizontal",
				mouseScrollNavigation:"off",
 							mouseScrollReverse:"default",
				onHoverStop:"off",
				touch:{
					touchenabled:"on",
					touchOnDesktop:"off",
					swipe_threshold: 75,
					swipe_min_touches: 50,
					swipe_direction: "vertical",
					drag_block_vertical: false
				}
				,
				bullets: {
					enable:true,
					hide_onmobile:false,
					style:"uranus",
					hide_onleave:false,
					direction:"vertical",
					h_align:"right",
					v_align:"bottom",
					h_offset:20,
					v_offset:50,
					space:5,
					tmp:'<span class="tp-bullet-inner"></span>'
				}
			},
			responsiveLevels:[1240,1024,778,480],
			visibilityLevels:[1240,1024,778,480],
			gridwidth:[1920,1280,778,480],
			gridheight:[1080,800,534,728],
			lazyType:"all",
			shadow:0,
			spinner:"spinner2",
			stopLoop:"off",
			stopAfterLoops:-1,
			stopAtSlide:-1,
			shuffle:"off",
			autoHeight:"off",
			fullScreenAutoWidth:"off",
			fullScreenAlignForce:"off",
			fullScreenOffsetContainer: "#header",
			fullScreenOffset: "",
			hideThumbsOnMobile:"off",
			hideSliderAtLimit:0,
			hideCaptionAtLimit:0,
			hideAllCaptionAtLilmit:0,
			debugMode:false,
			fallbacks: {
				ignoreHeightChanges:"mobile",
				ignoreHeightChangesSize:0,
				simplifyAll:"off",
				nextSlideOnWindowFocus:"off",
				disableFocusListener:true,
			}
		});
				}
  	
		
}
$(document).one("pageshow", "#list-collections", function(event) {
    createshopslider();
});

function createshopslider() {
  var htmlDiv = document.getElementById("rs-plugin-settings-inline-css"); var htmlDivCss="";
				if(htmlDiv) {
					htmlDiv.innerHTML = htmlDiv.innerHTML + htmlDivCss;
				}else{
					var htmlDiv = document.createElement("div");
					htmlDiv.innerHTML = "<style>" + htmlDivCss + "</style>";
					document.getElementsByTagName("head")[0].appendChild(htmlDiv.childNodes[0]);
				}
setREVStartSize({c: jQuery('#rev_slider_164_1'), responsiveLevels: [1240,1024,778,480], gridwidth: [1903,1200,778,480], gridheight: [475,300,250,225], sliderLayout: 'auto'});
			
var revapi164,
	tpj=jQuery;
	if(tpj("#rev_slider_164_1").revolution == undefined){
		revslider_showDoubleJqueryError("#rev_slider_164_1");
	}else{
		revapi164 = tpj("#rev_slider_164_1").show().revolution({
			sliderType:"standard",
			jsFileLocation:"",
			sliderLayout:"auto",
			dottedOverlay:"none",
			delay:9000,
			navigation: {
				onHoverStop:"off",
			},
			responsiveLevels:[1240,1024,778,480],
			visibilityLevels:[1240,1024,778,480],
			gridwidth:[1903,1200,778,480],
			gridheight:[475,300,250,225],
			lazyType:"all",
			shadow:0,
			spinner:"spinner2",
			stopLoop:"off",
			stopAfterLoops:-1,
			stopAtSlide:-1,
			shuffle:"off",
			autoHeight:"off",
			disableProgressBar:"on",
			hideThumbsOnMobile:"off",
			hideSliderAtLimit:0,
			hideCaptionAtLimit:0,
			hideAllCaptionAtLilmit:0,
			debugMode:false,
			fallbacks: {
				ignoreHeightChanges:"mobile",
				ignoreHeightChangesSize:0,
				simplifyAll:"off",
				nextSlideOnWindowFocus:"off",
				disableFocusListener:true,
			panZoomDisableOnMobile:"on",
			}
		});
	}
}



$(document).one("pageshow", "#pagereviews", function(event) {
    createreviewslider();
});

function createreviewslider() {
 var htmlDiv = document.getElementById("rs-plugin-settings-inline-css"); var htmlDivCss="";
				if(htmlDiv) {
					htmlDiv.innerHTML = htmlDiv.innerHTML + htmlDivCss;
				}else{
					var htmlDiv = document.createElement("div");
					htmlDiv.innerHTML = "<style>" + htmlDivCss + "</style>";
					document.getElementsByTagName("head")[0].appendChild(htmlDiv.childNodes[0]);
				}

setREVStartSize({c: jQuery('#rev_slider_165_1'), responsiveLevels: [1240,1024,778,480], gridwidth: [1903,1200,778,480], gridheight: [288,181,150,150], sliderLayout: 'auto'});
	var revapi165,
	tpj=jQuery;
			

if(tpj("#rev_slider_165_1").revolution == undefined){
		revslider_showDoubleJqueryError("#rev_slider_165_1");
	}else{
		revapi165 = tpj("#rev_slider_165_1").show().revolution({
			sliderType:"standard",
			jsFileLocation:"",
			sliderLayout:"auto",
			dottedOverlay:"none",
			delay:9000,
			navigation: {
				onHoverStop:"off",
			},
			responsiveLevels:[1240,1024,778,480],
			visibilityLevels:[1240,1024,778,480],
			gridwidth:[1903,1200,778,480],
			gridheight:[288,181,150,150],
			lazyType:"all",
			shadow:0,
			spinner:"spinner2",
			stopLoop:"off",
			stopAfterLoops:-1,
			stopAtSlide:-1,
			shuffle:"off",
			autoHeight:"off",
			disableProgressBar:"on",
			hideThumbsOnMobile:"off",
			hideSliderAtLimit:0,
			hideCaptionAtLimit:0,
			hideAllCaptionAtLilmit:0,
			debugMode:false,
			fallbacks: {
				ignoreHeightChanges:"mobile",
				ignoreHeightChangesSize:0,
				simplifyAll:"off",
				nextSlideOnWindowFocus:"off",
				disableFocusListener:true,
			panZoomDisableOnMobile:"on",
			}
		});
	}
}




function runig() {
  
 
 
    // what we post swiper
 var userfeed = new Instafeed({
        get: 'user',
        userId: 2215365748,
        limit: 30,
    target: jQuery(this).find('.instafeed').get(0),
    accessToken: '2215365748.1677ed0.5c0274f3c3d4443186e99f2abfd10542',
        resolution: 'low_resolution',               
            
        template: '<div class="swiper-slide"><img alt="{{caption}}" src="{{image}}" /></div>',
         
   mock: true,
   success: function(response) {

 console.log(response.data)
  var myStringArray = response.data;
  var arrayLength = myStringArray.length;
  for (var i = 0; i < arrayLength; i++) {
    //Do something
    $.mobile.activePage.find('.instafeed').append('<div class="swiper-slide"><div class="flex-video"><img  src="' + myStringArray[i].images.low_resolution.url + '" /></div></div>');

}
},
          after: function() { 
    
            var mySwiper = new Swiper ('.instagram-swiper', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    speed: 900,
    slidesPerView: 5,
    centeredSlides: true,
    spaceBetween: 10,
         autoplay: {
        delay: 2500,
        disableOnInteraction: true,
      },          
     breakpoints: {
    // when window width is <= 320px
    400: {
      slidesPerView: 3,
    }
    },
  }) 
         }
          
        });
    userfeed.run();
 
}



function menuOpen(){
    var scrollTop = window.document.body.scrollTop;
 //You can replace this with a regular menu open. I use some code that places the same menu panel on every page so that I only have to write it once, but it causes a duplicate ID of "menupanel"- hence the code that will only open #menupanel on the current active page
    jQuery('#mobilemenu').panel("open");
    window.document.body.scrollTop = scrollTop;
}


//review slider hompage
function reviewslider() {
  var container = jQuery('#reviewslider');
  var pagination = container.find('.swiper-pagination');

  // create the slider
            var swiper = new Swiper((container), {
                effect: 'slide',
                   speed: 800,
                   autoplay: {
        delay: 7000,
        disableOnInteraction: true,
      },
  // If we need pagination
      pagination: {
         el: pagination,
      },          
                breakpoints: {
    // when window width is <= 320px
    480: {
       speed: 300,
      }
     }
             
            });
  
}

function isDomElem(obj) {
      if(obj instanceof HTMLCollection && obj.length) {
          for(var a = 0, len = obj.length; a < len; a++) {
              if(!checkInstance(obj[a])) {
                  console.log(a);
                  return false;   
              }
          }     
          return true;                
      } else {
          return checkInstance(obj);  
      }

      function checkInstance(elem) {
          if((elem instanceof jQuery && elem.length) || elem instanceof HTMLElement) {
              return true;  
          }
          return false;        
      }
}





// change body classes
$(document).on("pagebeforeshow", ".ui-page", function (event, data) {
  var eventid = event.target.id;
 
  if(eventid.indexOf('collection') != -1){
  var eventid = 'template-' + eventid.substring(0, eventid.indexOf('-'));
   }  
  var dataPrev = data.prevPage[0];
  if(typeof dataPrev != 'undefined') {
     var previd = dataPrev.id;
     if(previd.indexOf('collection') != -1){
     var previd = 'template-' + previd.substring(0, previd.indexOf('-'));   
     }  
    if(previd.indexOf('index') != -1){
    var previd = 'template-' + previd + ' index';   
    } 
    if(eventid.indexOf('index') != -1){
    var eventid = 'template-' + eventid;   
    }
      jQuery(document.body).removeClass(previd).addClass(eventid);
  }else{
   jQuery(document.body).addClass(eventid);
  }
 
});

function createCookie(name,value,days) {
    if (days) {
        var date = new Date();
        date.setTime(date.getTime()+(days*24*60*60*1000));
        var expires = "; expires="+date.toGMTString();
    }
    else var expires = "";
    document.cookie = name+"="+value+expires+"; path=/";
}


function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
function eraseCookie(name) {
    createCookie(name,"",-1);
}
       

function popup() {

jQuery('body').addClass('md-show');
jQuery('#freeship').addClass('md-show');
  jQuery('#freeship .md-close').click(function() {
    jQuery('#freeship').removeClass('md-show');
     jQuery('body').removeClass('md-show');
  });
// stop it from coming up twice
 
// Build the expiration date string:
var expiration_date = new Date();
var cookie_string = '';
expiration_date.setFullYear(expiration_date.getFullYear() + 1);
// Build the set-cookie string:
cookie_string = "freeship=true; path=/; expires=" + expiration_date.toGMTString();
// Create/update the cookie:
document.cookie = cookie_string;
}


function discountpopup(discount) {

jQuery('body').addClass('md-show');
  jQuery('#discount').addClass('md-show').find('h3').append(' (Discount Code "'+discount+'" automatically applied at checkout)');

  jQuery('#discount .md-close').click(function() {
    jQuery('#discount').removeClass('md-show');
     jQuery('body').removeClass('md-show');
  });
// stop it from coming up twice
 

}

function getParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
    results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}






function initmodals(event) {
    var ModalEffects = (function() {

        function init() {

            var overlay = jQuery('.md-overlay').get(0);
            var body = jQuery(document.body).get(0);
             
            [].slice.call(body.querySelectorAll('.md-trigger')).forEach(function(el, i) {
                 
                   var modal = body.querySelector('#' + el.getAttribute('data-modal'));
                    
                    [].slice.call(body.querySelectorAll('.md-close')).forEach(function(el, i) {
                      
                     el.addEventListener('click', function(ev) {
                    //ev.stopPropagation();
                    removeModalHandler();
                });
                    });
              
              if( jQuery(modal).find('.md-close2').length) {
                 close2 = modal.querySelector('.md-close2');
                 close2.addEventListener('click', function(ev) {
                  //  ev.stopPropagation();
                    removeModalHandler();
                });
              }

                function removeModal(hasPerspective) {
                    classie.remove(modal, 'md-show');
                    classie.remove(body, 'md-show');
                    jQuery(modal).find('.jquery-youtube-tubeplayer').tubeplayer("pause");
                    if (hasPerspective) {
                        classie.remove(event.currentTarget.documentElement, 'md-perspective');
                    }
                }

                function removeModalHandler() {
                    removeModal(classie.has(el, 'md-setperspective'));
                }

                jQuery(el).off('click').on('click', function(ev) {
                    classie.add(modal, 'md-show');
                    classie.add(body, 'md-show');
                    var video = jQuery(modal).find('.videobox');
                  if(video.length) {  
                    if(video.tubeplayer('data') != undefined) {
                      video.tubeplayer("play");                     
                    }else{
                    video.loadvideo();
                    video.one('playerLoaded', function() {
                      if(window.mobile == undefined) {
                       video.tubeplayer("play");                       
                      }
                    }); 
                    }

                  }
                    overlay.removeEventListener('click', removeModalHandler);
                    overlay.addEventListener('click', removeModalHandler);

                    if (classie.has(el, 'md-setperspective')) {
                        setTimeout(function() {
                            classie.add(event.currentTarget.documentElement, 'md-perspective');
                        }, 25);
                    }
                });

               

            });

        }

        init();

    })();
}


jQuery(document).foundation();